import {Injectable} from "@angular/core";
import {UserService} from "../providers/user.service";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {UsersDgSearchResults} from "../models/datagrid-search-results/users.dg-search-results.model";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable()
export class UserResolve implements Resolve<UsersDgSearchResults> {
  constructor(private userService: UserService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<UsersDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.userService.getResults( environment.DEFAULT_RESULTS_LIMIT,0,'ASC','lastName').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
